export default __webpack_public_path__ + "media/5f0d62e1c9e7c40061009cad9f151d9ad6de3572e1efb2b13ade90b19ec0b2c9.svg";